import(/* webpackMode: "eager" */ "/home/runner/work/payments-platform-web-app/payments-platform-web-app/src/app/global-error.tsx");
